'use client';

import React from 'react';
import SplashButton from '@/components/SplashButton';
import { phoneHref } from '@/lib/siteSettings';

interface HeroCTAContactActionsProps {
  telephone: string;
  whatsappUrl: string;
  whatsappLabel?: string;
  callLabel?: string;
}

/**
 * WhatsApp + Call pair shown under the hero contact form. Uses the existing
 * SplashButton in `as="button"` mode (with onClick) rather than its link mode:
 * SplashButton's link path routes through the client page-transition router,
 * which mishandles `tel:`/external `wa.me` targets in production. Number + link
 * come from the `site_settings` Prismic singleton via getSiteSettings.
 */
export default function HeroCTAContactActions({
  telephone,
  whatsappUrl,
  whatsappLabel = 'WhatsApp Us',
  callLabel,
}: HeroCTAContactActionsProps) {
  return (
    <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
      <SplashButton
        as="button"
        color="transparentblue"
        size="lg"
        grow
        text={whatsappLabel}
        onClick={() => window.open(whatsappUrl, '_blank', 'noopener,noreferrer')}
      />
      <SplashButton
        as="button"
        color="transparentblue"
        size="lg"
        grow
        text={callLabel ?? `Call ${telephone}`}
        onClick={() => {
          window.location.href = phoneHref(telephone);
        }}
      />
    </div>
  );
}
